import Auth from './index';
import { List } from 'immutable';

var hasPermission = function hasPermission(permission) {
  return Auth.checkPermissions(List([permission]));
};

export default hasPermission;